import { render } from "./BaseEqualizerElement.vue?vue&type=template&id=492f6d59"
const script = {}

import exportComponent from "C:\\Projekte\\wordpress\\eh3\\wp-content\\themes\\io.shop-standalone-energiehoch3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__